module.exports = __webpack_public_path__ + "img/feature-3.de6c8227.webp";